import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import * as yup from "yup";
import { toast } from "react-toastify";
import { Button, Form, Input, Loader } from "semantic-ui-react";
import { isAuthAdmin } from "../../../../../services/auth";
import { Container, Content, Title, Image } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import Dropzone from "../../../../../components/Admin/Dropzone";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

const EditarCertificado = (props) => {
  const [selectedFile, setSelectedFile] = useState("");
  const [certificado, setCertificado] = useState({
    id_curso: "a",
    url_image: "",
  });
  const [loading, setLoading] = useState(true);
  const { id } = props.match.params;

  useEffect(() => {
    api
      .get(`/certificados/curso/templates/read/${id}`)
      .then((res) => {
        let array = {
          local: "ead/certificadoCurso",
          texto: `listou o modelo de certificado curso de id=${id}`,
        };
        api.post("system_logs", { acao: JSON.stringify(array) });
        setCertificado(res.data);
        setLoading(false);
        setSelectedFile(res.data.url_image);
      })
      .catch((err) => {
        swal(
          "Não foi possível carregar os Certificado's",
          err,
          ""
        ).then((res) => props.history.push("/"));
      });
  }, []);

  useEffect(() => {}, [certificado]);

  const uploadImage = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFile);
      inputData.append("path", "imagens-voitto/imagens-blog/meta/certificados");

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      setCertificado({ ...certificado, url_image: url });

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const update = useCallback(async () => {
    await setCertificado({ ...certificado });

    const certificadoValidation = await yup.object().shape({
      id_curso: yup
        .number("Necessário que informe o id do curso")
        .required("Necessário que informe a id do curso"),
      url_image: yup
        .string("Necessário que informe a imagem")
        .required("Necessário que informe a imagem"),
    });

    try {
      await certificadoValidation.validate(certificado, { abortEarly: true });
      api
        .put(`/certificados/curso/templates/${id}`, certificado)
        .then((res) => {
          let array = {
            local: "ead/certificadoCurso",
            texto: `editou os modelos de certificado curso de id=${id}`,
          };
          api.post("system_logs", { acao: JSON.stringify(array) });
          props.history.push("/admin/ead/certificados/cursos");
        })
        .catch((err) => {
          swal("Não foi possível salvar o Certificado", err, "");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  }, [certificado]);

  return (
    <>
      <Container>
        <AdminMenu />

        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Editar Certificado {id}</Title>

            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Id do curso"
                  placeholder="Id do curso"
                  value={certificado?.id_curso}
                  onChange={(e) => {
                    setCertificado({
                      ...certificado,
                      id_curso: e.target.value,
                    });
                  }}
                />
              </Form.Group>

              <Form.Group>
                <Form.Field>
                  <Dropzone onFileUploaded={setSelectedFile} />
                </Form.Field>
              </Form.Group>
              <Image src={certificado?.url_image} />
              <Form.Field>
                <Button color="primary" onClick={() => uploadImage()}>
                  Subir imagem
                </Button>
              </Form.Field>
              <Form.Group>
                <Form.Field control={Button} onClick={() => update()}>
                  Salvar
                </Form.Field>
                <Link to="/admin/ead/certificados/cursos">
                  <Button color="secondary">Cancelar</Button>
                </Link>
              </Form.Group>
            </Form>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(EditarCertificado);
